"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ZoomControlIcon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 32px;\n  width: 32px;\n  background: ", ";\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  height: 32px;\n  width: 32px;\n  background: ", ";\n  justify-content: center;\n  align-items: center;\n\n  svg {\n    width: 20px;\n    height: 20px;\n    fill: ", ";\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.map.zoomControlBackground;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.map.zoomControlColor;
});
ZoomControlIcon.displayName = 'ZoomControlIcon';
var ZoomControl = function (_a) {
    var onClick = _a.onClick, icon = _a.icon;
    return (react_1.default.createElement(ZoomControlIcon, { onClick: onClick }, icon));
};
ZoomControl.displayName = 'ZoomControl';
exports.default = ZoomControl;
var templateObject_1;
//# sourceMappingURL=zoom-control.component.js.map